export enum UpdateFrequencyEnum {
  immediate,
  daily
}
